import { useOktaAuth } from '@okta/okta-react';
import { useMutation } from '@tanstack/react-query';
import { useErrorStore } from '@oai-frontend-monorepo/state-management';

interface Params {
  onSuccess?: (data: string) => void;
  retry?: number;
}

const useSignIn = ({ onSuccess, retry = 0 }: Params) => {
  const { oktaAuth } = useOktaAuth();

  return useMutation<string, any, { email?: string; password?: string }>({
    mutationKey: ['sign-in'],
    retry,
    retryDelay: 500,
    mutationFn: async ({ email, password }) => {
      try {
        if (!email || !password) {
          throw new Error('Email and password are required');
        }

        console.log('email', email);

        // sign in via okta
        const res = await oktaAuth.signIn({
          username: email,
          password: password,
        });

        console.log('sigin in res', res);

        if (res.status === 'SUCCESS') {
          // Session token
          const sessionToken = res.sessionToken;

          console.log('getting tokens', sessionToken);

          // Exchange the session token for an access token
          const tokens = await oktaAuth.token.getWithoutPrompt({
            responseType: 'code',
            scopes: ['openid', 'email', 'offline_access'],
            sessionToken: sessionToken,
          });

          console.log('tokens', tokens);

          // store tokens in okta token manager
          oktaAuth.tokenManager.setTokens(tokens.tokens);

          // return the access token
          const accessToken = tokens.tokens.accessToken?.accessToken;

          if (!accessToken) {
            throw new Error('An unknown error occurred');
          }

          console.log('returning access token', accessToken);

          return accessToken;
        } else {
          console.log('error');
          throw new Error('Sign in not successful');
        }
      } catch (e) {
        console.log('error', e);
        throw e;
      }
    },
    onSuccess(data) {
      onSuccess?.(data);
    },
    onError(err) {
      useErrorStore
        .getState()
        .setErrorMessage(err?.message || 'Invalid email or password');
    },
  });
};

export default useSignIn;
